<script></script>
<section class="section-my-reservation">
  <div class="container-my-reservation">
    <div class="header-my-reservation">
      <div class="icon-my-reservation">
        <i class="bi bi-calendar-day"></i>
      </div>
      <div class="text-my-reservation">
        <h3>{{ "MyReservation" | translate }}</h3>
      </div>
    </div>
    <div class="content-my-reservation">
      <div class="item-my-reservation">
        <h4>{{ "TypeOfService" | translate }}</h4>
        <p>{{ tip_service ? (tip_service | translate) : "-" }}</p>

        <!-- <div *ngfor="let reserv of Object.keys(dato)">
                    <p>{{reserv}}</p>
                </div> -->
      </div>

      <div class="item-my-reservation">
        <h4>{{ "Mileage" | translate }}</h4>
        <p>{{ kilometraje ? kilometraje : "-" }}</p>
      </div>
      <div class="item-my-reservation" *ngIf="brandUrl === '8'">
        <h4>{{"Make" |translate | capitalize}}</h4>
        <p>{{ make ? make : "-"}}</p>
      </div>
      
      <div class="item-my-reservation">
        <h4>{{ "Location" | translate }}</h4>
        <p>{{ cityName }}</p>
      </div>

      <div class="item-my-reservation">
        <h4>{{ "Dealer" | translate }}</h4>
        <p>{{ taller }}</p>
      </div>

      <div class="item-my-reservation">
        <h4>{{ "Advisor" | translate }}</h4>
        <p>{{ asesor ? asesor : "-" }}</p>
      </div>

      <div class="item-my-reservation">
        <h4>{{ "Date" | translate }}</h4>
        <p>{{ date === "Invalid date" || !date ? "-" : date }}</p>
      </div>

      <div class="item-my-reservation">
        <h4>{{ "Hours" | translate }}</h4>
        <p>{{ time ? time : "-" }}</p>
      </div>
    </div>
  </div>
</section>
